<template>
  <div
    id="app"
    class="d-flex w-100"
    :class="{ 'h-100' : fullHeight }"
  >
    <router-view />

    <div
      class="banner banner-left border"
      data-test="cookie-consent-modal"
      style="background-color: #fff;"
      v-if="showBanner"
    >
      <div class="cookie-consent-banner__inner">
        <div class="cookie-consent-banner__copy">
          <div
            class="cookie-consent-banner__description"
            style="color: #505050;"
          >
            We use third-party cookies to analyse web traffic.
            <a
              href="https://www.smartology.net/cookie-policy/"
              class="link-btn"
              style="color: #505050;"
              target="_blank"
            >Read more about cookies</a>
          </div>
        </div>
        <div class="buttons">
          <button
            type="button"
            id="acceptCookies"
            data-test="accept-cookies-button"
            @click="acceptCookies"
            class="cookie-consent-btn"
          >
            Accept
          </button>
          <button
            type="button"
            id="rejectCookies"
            data-test="reject-cookies-button"
            @click="rejectCookies"
            class="cookie-consent-btn-secondary"
            style="background-color: #E8E8E8; color: #636363;"
          >
            Reject
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import helper from '@/core/helper';

export default {
  data() {
    return {
      loggedIn: false,
      fullHeight: false,
      showBanner: true,
    };
  },
  computed: {
    isProduction() {
      return process.env.NODE_ENV === 'production';
    },
  },
  methods: {
    acceptCookies() {
      this.$gtm.enable(true);
      this.setLocalStorageItem('cookieConsent', true);
      this.showBanner = false;
    },
    rejectCookies() {
      this.$gtm.enable(false);
      this.setLocalStorageItem('cookieConsent', false);
      this.showBanner = false;
    },
    setLocalStorageItem(itemKey, itemValue) {
      localStorage.setItem(itemKey, JSON.stringify(itemValue));
    },
  },
  mounted() {
    const cookieConsent = helper.getLocalStorageItem('cookieConsent');
    if (cookieConsent !== null) {
      this.showBanner = false;
      if (cookieConsent === 'true') this.$gtm.enable(true);
    }
  },
  watch: {
    $route() {
      this.fullHeight = !!(this.$route.meta.fullHeight);
    },
  },
};
</script>

<style scoped>
.banner {
  position: fixed;
  bottom: 0;
  z-index: 1000;
  box-sizing: border-box;
  min-width: 280px;
  width: -moz-calc(100% - 20px);
  width: -webkit-calc(100% - 20px);
  width: -o-calc(100% - 20px);
  width: calc(100% - 20px);
  margin: 10px 10px;
  padding: 2px 20px;
  border-radius: 20px;
  -webkit-box-shadow: 10px 10px 36px -13px rgba(0,0,0,.15);
  -moz-box-shadow: 10px 10px 36px -13px rgba(0,0,0,.15);
  box-shadow: 10px 10px 36px -13px rgba(0,0,0,.15)
}

.banner-left {
  left: 0
}

.banner-right {
  right: 0
}

.border {
  border: 1px;
  border-style: solid;
  border-width: 1px;
  border-color: #e9e9e9
}

.cookie-consent-banner__inner {
  padding: 15px 0;
  max-width: 375px;
  margin: 0 auto;
}

.cookie-consent-banner__copy {
  margin-bottom: 20px
}

.cookie-consent-banner__description {
  font-weight: 400;
  font-size: .9em
}

.cookie-consent-btn {
  display: inline-block;
  width: 49%;
  padding: 11px 13px;
  border-radius: 10px;
  border: none;
  font-size: .8em;
  text-decoration: none;
  text-align: center;
  font-weight: 400;
  transition: .4s
}

.cookie-consent-btn:hover {
  text-decoration: none;
  opacity: .9
}

.cookie-consent-btn-secondary {
  display: inline-block;
  padding: 11px 13px;
  width: 49%;
  border-radius: 10px;
  border: none;
  font-size: .8em;
  margin-left: .2em;
  text-decoration: none;
  text-align: center;
  font-weight: 400;
  transition: .3s;
  background-color:#0c343d;
  color:#ffffff;
}

.cookie-consent-btn-secondary:hover {
  text-decoration: none;
  opacity: .9
}

.prebanner {
  position: fixed;
  bottom: 0;
  z-index: 2147483645;
  height: 50px;
  font-size: .9em;
  margin: 10px 10px;
  border: none;
  padding: 12px 18px;
  border-radius: 20px;
  text-decoration: none;
  -webkit-box-shadow: 10px 10px 36px -13px rgba(0,0,0,.15);
  -moz-box-shadow: 10px 10px 36px -13px rgba(0,0,0,.15);
  box-shadow: 10px 10px 36px -13px rgba(0,0,0,.15)
}

.prebanner-left {
  left: 0
}

.prebanner-right {
  right: 0
}

.prebanner:hover {
  text-decoration: none
}

.link-btn {
  text-decoration: underline
}

.link-btn:hover {
  text-decoration: underline
}
</style>
